import { render, staticRenderFns } from "./Kursovaya.vue?vue&type=template&id=27100dd5&lang=pug&"
import script from "./Kursovaya.vue?vue&type=script&lang=ts&"
export * from "./Kursovaya.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports